module.exports = __webpack_public_path__ + "static/media/Warning.0595eadb.svg";